import { useBrandGroupConfig } from './useBrandGroupConfig';
import { BRAND_LOGO_TYPE } from '../types/general';
import { BrandConfig } from '../types/apiConfig';
import { useQueryParams } from './useQueryParams';

const chameleonVersion = '7.35.0';

export function useBrandLogo() {
  const brandGroupConfigHook = useBrandGroupConfig();
  const { brand } = useQueryParams();
  const defaultBrandConfig = brandGroupConfigHook.getBrandConfigFromBrandId(brand);

  // Pass a brand configuration or default to current brand to get the matching logo.
  function getBrandLogo(type: BRAND_LOGO_TYPE, brandConfig?: BrandConfig) {
    const config = brandConfig || defaultBrandConfig;

    if (config) {
      const logoType = String(type);
      if (logoType === BRAND_LOGO_TYPE.DEFAULT || logoType === 'main') {
        if (config.designSystem.overrides?.brandMain)
          return config.designSystem.overrides.brandMain;
      }
      if (logoType === 'square-main') {
        if (config.designSystem.overrides?.brandSquareMain)
          return config.designSystem.overrides.brandSquareMain;
      }
      if (config.designSystem.themeKey) {
        return `https://focus.mediahuisgroup.com/raw/prod-mh-design-system/${chameleonVersion}/${config.designSystem.themeKey}/logos/logo-${logoType}.svg`;
      }
    }
  }

  return getBrandLogo;
}
